import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

import { catchError, map, Observable, throwError } from 'rxjs';

import { IAcceptInvitation, SignUpRequest } from '@app/features/auth/interfaces/auth.interface';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.apiUrl; // 🔹 Replace with your API
 inviteData = signal<any>(null)
  constructor(private http: HttpClient) { }

  userSignUp(data: SignUpRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/register`, data).pipe(map((user) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  userLogin(data: SignUpRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/login`, data).pipe(map((user) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  resendEmail(data: any) : Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/resend-verification`, data).pipe(map((user) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  forgotPassword(data : string | any) : Observable<any>{
     return this.http.post<any>(`${this.baseUrl}/auth/forgot-password`, data).pipe(map((user) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  resetPassword(data : any) {
        return this.http.post<any>(`${this.baseUrl}/auth/reset-password`, data).pipe(map((user) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  verifyInvitationToken(token : string) :Observable<{success : boolean , data : IAcceptInvitation}> {
  return this.http.get<{success : boolean , data :IAcceptInvitation}>(`${this.baseUrl}/check-invitation-token/${token}`).pipe(map((res :{success : boolean , data :IAcceptInvitation}) => res))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  acceptInvitaion(token : string) : Observable<any> {
     return this.http.post<any>(`${this.baseUrl}/workspaces/accept-invitation`, {token : token}).pipe(map((res :any) => res))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  logOut() :Observable<{success : boolean ,message : string}> {
     return this.http.post<{success : boolean ,message : string}>(`${this.baseUrl}/auth/logout`,{}).pipe(map((user : {success : boolean ,message : string}) => user))
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}